/**
 * Analytics Services Index
 * Tüm ürün bazlı analytics servislerini export eder
 */

import { busService } from "./bus";
import { flightService } from "./flight";
import { ProductType } from "../constants/products";
import { hotelService } from "./hotel";
import { ferryService } from "./ferry";
import { carService } from "./car";

// Ürün bazlı servis mapping
export const productServices = {
  [ProductType.BUS]: busService,
  [ProductType.FLIGHT]: flightService,
  [ProductType.HOTEL]: hotelService,
  [ProductType.CAR]: carService, // İleride eklenecek
  [ProductType.FERRY]: ferryService,
};

/**
 * Ürün tipine göre servis seçer
 * @param {string} productType - Ürün tipi (bus, ferry, flight, car)
 * @returns {object} - İlgili ürün servisi
 */
export const getServiceByProductType = (productType) => {
  return productServices[productType] || null;
};
